import { styled } from '@mui/material';

import { Avatar } from '../../ui-kit/avatar/avatar.component';
import { EnvironmentLabel } from '../../ui-kit/environment-label/environment-label.component';
import { IconButton } from '../../ui-kit/icon-button/icon-button.component';
import { shouldForwardProps } from '../../utils/mui-styled.utils';

export const StyledWidgetHeaderCloseBtn = styled(IconButton)(
	({
		theme: {
			palette: { colorScheme, sizes },
		},
	}) => ({
		width: sizes.size_6,
		height: sizes.size_5,
		padding: 0,
		...colorScheme.customStyle.header?.closeButton,
	}),
);

export const StyledWidgetHeaderMenu = styled('div')(
	({
		theme: {
			palette: { sizes },
		},
	}) => ({
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		'& > *:first-of-type': {
			marginRight: sizes.size_1,
		},
	}),
);

export const StyledWidgetHeaderEnvLabel = styled(EnvironmentLabel)({
	position: 'absolute',
	top: 2,
	left: '50%',
	transform: 'translateX(-50%)',
});

interface ResponsiveFlags {
	isMobile: boolean;
	isSmallHeight: boolean;
	isOpen: boolean;
}

export const StyledWidgetHeaderRoot = styled('header', {
	shouldForwardProp: shouldForwardProps(['isMobile', 'isSmallHeight', 'isOpen']),
})<ResponsiveFlags>(
	({
		theme: {
			palette: {
				colorScheme,
				sizes,
				transitionConfig: { noAnimationTransition },
			},
		},
		isMobile,
		isSmallHeight,
		isOpen,
	}) => ({
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		position: 'relative',
		zIndex: 4,
		top: '2%',
		opacity: 0,
		transitionDelay: noAnimationTransition ? '0s' : '100ms',
		transition: noAnimationTransition ? 'initial' : 'all 0.4s ease',
		padding: isMobile || isSmallHeight ? sizes.size_2 : sizes.size_3,
		backgroundColor: 'transparent',

		...(isOpen && {
			top: 0,
			opacity: 1,
		}),
		...colorScheme?.customStyle?.header?.main,
	}),
);

export const StyledWidgetHeaderAvatar = styled(Avatar, {
	shouldForwardProp: shouldForwardProps(['isOpen']),
})<Pick<ResponsiveFlags, 'isOpen'>>(({ isOpen }) => ({
	transform: 'translateY(0)',
	opacity: 1,
	transition: 'opacity 1s, transform 0s',
	transitionDelay: '0.5s',
	...(isOpen && {
		transition: 'opacity 0.3s, transform 0.67s',
		transform: 'translateY(-30px)',
		opacity: 0,
		transitionDelay: '0s',
	}),
}));

export const StyledWidgetHeaderLiveChatTitle = styled('h4', {
	shouldForwardProp: shouldForwardProps(['isShown', 'isLeaving']),
})<{
	isShown: boolean;
	isLeaving: boolean;
}>(({ isShown, isLeaving }) => ({
	margin: '0',
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flex: 1,
	textAlign: 'center',
	padding: '17px 0',
	zIndex: -1,
	opacity: isShown && !isLeaving ? 1 : 0,
	transition: 'opacity 0.5s',
	transitionDelay: isShown && !isLeaving ? '0.5s' : '0s',
}));
